export default __webpack_public_path__ + "static/media/pdf.292bf553.pdf";